app.service('uploadFile', function (modal, loading) {

	var post, $box;

	function remove() {
		loading.start();
		$.ajax({
			url: post,
			type:'POST',
			dataType: 'json',
			success: function (json) {
				loading.stop();
				if(json.status == 'SUCCESS'){
					$box.addClass('empty');
					$box.removeClass('selected');
				} else {
					modal.alert(json.message);
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd usuwania pliku');
			}
		});
	}
	function add() {
		loading.start();
		let input = $box[0].querySelector('input[type=file]');
		let formData = new FormData();
		if(input.files[0]){
			let fileData = input.files[0];
			formData.append("file", fileData);
			$.ajax({
				url: post,
				type:'POST',
				dataType: 'json',
				data: formData,
				processData: false,
				contentType: false,
				success: function (json) {
					loading.stop();
					if(json.status == 'SUCCESS'){
						input.value='';
						$box.removeClass('empty');
						$box.find('.file').attr('href', json.filePath).text(json.fileName);
					} else {
						modal.alert(json.message);
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd dodawania pliku');
				}
			});
		} else {
			modal.alert('Nie ma pliku do wysłania')
		}
	}

	function init() {
		$('body').on('click', '.js-upload-remove', function () {
			$box = $(this).closest('.group-upload-row');
			post = $(this).data('post');
			remove();
		}).on('click', '.js-upload-add', function () {
			$box = $(this).closest('.group-upload-row');
			post = $(this).data('post');
			add();
		}).on('change', '.group-upload-row input[type=file]', function () {
			let $parent = $(this).closest('.group-upload-row');
			if(this.files && this.files.length){
				$parent.addClass('selected');
			} else {
				$parent.removeClass('selected');
			}
		});
	}


	return {
		init
	}
});
